import * as React from "react";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export default function FloatingCallButton() {
  const [showFloatingButton, setShowFloatingButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setShowFloatingButton(scrollTop > 300);
    };

    // Check initial position in case user loads page already scrolled
    handleScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Phone number used for tel link
  const phoneNumber = "+18002090330";

  if (!showFloatingButton) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 md:hidden">
      <Button
        asChild
        size="lg"
        className="bg-green-100 hover:bg-green-200 text-green-600 shadow-lg rounded-full px-6 py-3 text-base font-semibold transition-all duration-300"
      >
        <a href={`tel:${phoneNumber}`} aria-label="Call us">
          <Phone className="mr-2 h-5 w-5 inline-block" />
          Call Us
        </a>
      </Button>
    </div>
  );
}
